module.exports = __webpack_public_path__ + "static/logo-white-50248ba74235ec87290e336aea7e2bfc.svg";